if (!customElements.get('icon-text-banner')) {
  class IconTextBanner extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (this.dataset.linked !== 'true') return;

      this.link = this.querySelector('[data-icon-text-banner-link]');
      if (!this.link) return;

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      if (!this.link || event.defaultPrevented) return;
      if (event.target === this.link || this.link.contains(event.target)) return;
      if (event.target.closest('a, button, input, select, textarea, summary')) return;

      if (window.Shopify && Shopify.designMode) {
        event.preventDefault();
        return;
      }

      const href = this.link.getAttribute('href');
      if (!href) return;

      if (event.metaKey || event.ctrlKey) {
        window.open(href, '_blank', 'noopener');
        return;
      }

      window.location.href = href;
    }
  }

  customElements.define('icon-text-banner', IconTextBanner);
}
